import React, { useState } from "react";
import client, { apiErr } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await client.post("/contact", form);
      toast.success("Message sent! We'll get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-xl px-5 py-16 sm:px-8">
      <span className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl bg-primary/10 text-primary"><Mail className="h-6 w-6" /></span>
      <h1 className="text-center font-display text-3xl font-extrabold tracking-tight">Get in touch</h1>
      <p className="mt-2 text-center text-muted-foreground">Have a question? Send us a message.</p>
      <form onSubmit={submit} className="mt-8 studio-card space-y-4 p-6">
        <div><Label>Name</Label><Input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" /></div>
        <div><Label>Email</Label><Input type="email" data-testid="contact-email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" /></div>
        <div><Label>Message</Label><Textarea rows={4} data-testid="contact-message" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1.5 resize-none" /></div>
        <Button type="submit" disabled={busy} className="w-full rounded-full" data-testid="contact-submit">{busy ? "Sending…" : "Send message"}</Button>
      </form>
    </div>
  );
}
